export interface FitResult {
  width: number;
  height: number;
  scale: number;
}

export function fitContent(contentWidth: number, contentHeight: number, viewportWidth: number, viewportHeight: number, padding = 24): FitResult {
  if (contentWidth <= 0 || contentHeight <= 0 || viewportWidth <= 0 || viewportHeight <= 0) return { width: 0, height: 0, scale: 0 };
  const scale = Math.min(Math.max(1, viewportWidth - padding * 2) / contentWidth, Math.max(1, viewportHeight - padding * 2) / contentHeight);
  return { width: Math.max(1, Math.round(contentWidth * scale)), height: Math.max(1, Math.round(contentHeight * scale)), scale };
}

export function clampZoom(zoom: number, min = 0.25, max = 4): number {
  return Math.min(max, Math.max(min, Number.isFinite(zoom) ? zoom : 1));
}
